module.exports = __webpack_public_path__ + "img/th_th1.121a08e0.png";